import { render, staticRenderFns } from "./LanguagesSwitch.vue?vue&type=template&id=5c98ea4b&"
import script from "./LanguagesSwitch.vue?vue&type=script&lang=js&"
export * from "./LanguagesSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports